import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import Button from '@material-ui/core/Button'
import {withStyles} from '@material-ui/core/styles'

const styles = theme => ({
    buttonPadding: {
        margin: '10px',
        'border-radius': '10px',
    },
})

const Portfolio = (props) => {
    const {classes} = props
    const {t} = useTranslation()
    const language = useSelector(state => state.language)
    switch (language) {
        case 'RU':
            return (
                <section id="portfolio">
                    <div className="row">
                        <div className="twelve columns collapsed">
                            <h2>{t('services')}</h2>
                            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
                            </div>
                        </div>

                        <Link to="/optilume"
                        >
                            <button className={classes.buttonPadding}>Optilume - Drug-coated Balloon for Treatment of Anterior Urethral Strictures</button>
                        </Link>
                        
                        <Link to="/bph"
                        >
                            <button className={classes.buttonPadding}>Rezum - Water Vapor Treatment of Benign Prostatic Hyperplasia</button>
                        </Link>                        
                        
                        <Link to="/Peyronie">
                            <button className={classes.buttonPadding}>Multimodal Non-invasive Treatment of Peyronie’s Disease</button>
                        </Link>
                        <Link to="/eswt"
                        >
                            <button className={classes.buttonPadding}>Multimodal Treatment of Erectile Dysfunction</button>
                        </Link>

                        <Link to="/Schokwave">
                            <button className={classes.buttonPadding}>Schokwaves for treatment of urogenital tract disease</button>
                        </Link>
                        <Link to="/HIFEM">
                            <button className={classes.buttonPadding}>HIFEM (High-Intensity Focused Electro-Magnetic) Treatment of Erectile Dysfunction</button>
                        </Link>
                        <Link to="/space-oar"
                        >
                            <button className={classes.buttonPadding}>SpaceOAR - Hydrogel for Prostate Cancer Patients undergoing Radiation Therapy</button>
                        </Link>
                        <Link to="/Uro">
                            <button className={classes.buttonPadding}>Урологические услуги</button>
                        </Link>
                    </div>
                </section>
            )
        case 'BG':
            return (
                <section id="portfolio">
                    <div className="row">
                        <div className="twelve columns collapsed">
                            <h2>{t('services')}</h2>
                            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
                            </div>
                        </div>
                        <ol>
                        <li> <Link to="/optilume"
                        >
                            <button className={classes.buttonPadding}>Optilume - Drug-coated Balloon for Treatment of Anterior Urethral Strictures</button>
                        </Link></li>
                        <li> <Link to="/Peyronie">
                            <button className={classes.buttonPadding}>Multimodal Non-invasive Treatment of Peyronie’s Disease</button>
                        </Link></li>
                        <li> <Link to="/eswt"
                        >
                            <button className={classes.buttonPadding}>Multimodal Treatment of Erectile Dysfunction</button>
                        </Link></li>
                        <li> <Link to="/rezum"
                        >
                            <button className={classes.buttonPadding}>Rezum - Water Vapor Treatment of Benign Prostatic Hyperplasia</button>
                        </Link></li>
                        <li> <Link to="/Schokwave">
                            <button className={classes.buttonPadding}>Schokwaves for treatment of urogenital tract disease</button>
                        </Link></li>
                        <li><Link to="/HIFEM">
                            <button className={classes.buttonPadding}>HIFEM (High-Intensity Focused Electro-Magnetic) Treatment of Erectile Dysfunction</button>
                        </Link></li>
                        <li> <Link to="/space-oar"
                        >
                            <button className={classes.buttonPadding}>SpaceOAR - Hydrogel for Prostate Cancer Patients undergoing Radiation Therapy</button>
                        </Link></li>
                        <li> <Link to="/Uro">
                            <button className={classes.buttonPadding}>Други Урологични услуги</button>
                        </Link></li>
                        </ol>
                    </div>
                </section>
            )
        case 'EN':
            return (



                <section id="portfolio">
                    <div className="row">
                        <div className="twelve columns collapsed">
                            <h2>{t('services')}</h2>
 
                        </div >
                        <ol>
                       <li> <Link to="/optilume">
                            <button className={classes.buttonPadding}>Optilume - Drug-coated Balloon for Treatment of Anterior Urethral Strictures</button>
                        </Link></li>
                          <li> <Link to="/bph">
                            <button className={classes.buttonPadding}>Minimally invasive surgical therapies for benign prostatic hypertrophy (BPH) </button>
                        </Link></li>
                         <li> <Link to="/Peyronie">
                            <button className={classes.buttonPadding}>Multimodal Non-invasive Treatment of Peyronie’s Disease</button>
                        </Link></li>

                         <li> <Link to="/eswt">
                            <button className={classes.buttonPadding}>Multimodal Treatment of Erectile Dysfunction</button>
                        </Link> </li>


                          <li> <Link to="/Schokwave">
                            <button className={classes.buttonPadding}>Schokwaves for treatment of urogenital tract disease</button>
                        </Link></li>

                         <li>  <Link to="/space-oar">
                            <button className={classes.buttonPadding}>SpaceOAR - Hydrogel for Prostate Cancer Patients undergoing Radiation Therapy</button>
                        </Link></li>
                          <li> <Link to="/Uro">
                            <button className={classes.buttonPadding}>General Urological services</button>
                        </Link></li>
                        </ol>
                    </div>
                </section>
            )
        default:
            return (
                <section id="portfolio">
                    <div className="row">
                        <div className="twelve columns collapsed">
                            <h2>{t('services')}</h2>
 
                       </div >
                        <ol>
                       <li> <Link to="/optilume">
                            <button className={classes.buttonPadding}>Optilume - Drug-coated Balloon for Treatment of Anterior Urethral Strictures</button>
                        </Link></li>

                         <li> <Link to="/Peyronie">
                            <button className={classes.buttonPadding}>Multimodal Non-invasive Treatment of Peyronie’s Disease</button>
                        </Link></li>

                         <li> <Link to="/eswt">
                            <button className={classes.buttonPadding}>Multimodal Treatment of Erectile Dysfunction</button>
                        </Link> </li>

                          <li> <Link to="/rezum">
                            <button className={classes.buttonPadding}>Rezum - Water Vapor Treatment of Benign Prostatic Hyperplasia</button>
                        </Link></li>
                          <li> <Link to="/Schokwave">
                            <button className={classes.buttonPadding}>Schokwaves for treatment of urogenital tract disease</button>
                        </Link></li>
                         <li>  <Link to="/space-oar">
                            <button className={classes.buttonPadding}>SpaceOAR - Hydrogel for Prostate Cancer Patients undergoing Radiation Therapy</button>
                        </Link></li>
                          <li> <Link to="/Uro">
                            <button className={classes.buttonPadding}>General Urological services</button>
                        </Link></li>
                        </ol>
                    </div>
                </section>
            )
    }

}

export default withStyles(styles)(Portfolio)


//                        <li><Link to="/HIFEM">
//                             <button className={classes.buttonPadding}>HIFEM (High-Intensity Focused Electro-Magnetic) Treatment of Erectile Dysfunction</button>
//                         </Link></li>





// WEBPACK FOOTER //
// ./src/Components/Portfolio.js